export const companyDetails = {
  name: 'King Edward VII',
  gymId: '5d8e1e56c6f34f3df9bac233',
  email: 'kingedward@encoregroup.co.uk',
  styles: {
    fontFamily: 'Montserrat',
    primary: '#414142',
    secondary: '#80b91e',
    accent: '#939799',
    accentDark: '#414142'
  },
  googleMaps: { lat: 53.9592279, lng: -1.0781796 },
  isHomepageHeroDark: true,
  locationsPage: {
    showUpcomingEvents: false,
    upcomingEventsClassTypes: ['class', 'induction']
  }
};
